module.exports = __webpack_public_path__ + "img/zhibo.906abd74.png";